var Assam = "아삼";
var Bihar = "비하르";
var Chandigarh = "찬디가르";
var Chhattisgarh = "차티스가르";
var Delhi = "델리";
var Goa = "고아";
var Gujarat = "구자라트";
var Haryana = "하리아나";
var Jharkhand = "자르칸드";
var Karnataka = "카르나타카";
var Kerala = "케랄라";
var Lakshwadeep = "락샤드위프";
var Maharashtra = "마하라슈트라";
var Manipur = "마니푸르";
var Meghalaya = "메갈라야";
var Mizoram = "미조람";
var Nagaland = "나갈랜드";
var Orrisa = "오디샤";
var Puducherry = "푸두체리";
var Punjab = "펀자브";
var Rajasthan = "라자스탄";
var Sikkim = "시킴";
var Telangana = "텔랑가나";
var Tripura = "트리푸라";
var Uttrakhand = "우타라칸드";
var INStates = {
	"Andaman and Nicobar Islands": "안다만니코바르 제도",
	"Andhra Pradesh": "안드라프라데시",
	"Arunachal Pradesh": "아루나찰프라데시",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "다드라나가르하벨리",
	"Daman & Diu": "다만 디우",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "히마찰프라데시",
	"Jammu and Kashmir": "자뮤카슈미르",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "마디아 프라데시",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "타밀 나두",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "우타르프라데시",
	Uttrakhand: Uttrakhand,
	"West Bengal": "서벵골"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
